import * as v from "valibot";

import type { components as OpenAPI } from "@/autogen/openapi";

export type Type = OpenAPI["schemas"]["EmailType"];

// Be careful when changing the order of these! It is directly used in the UI.
export const PRETTY_TYPE: Record<Type, string> = {
  public: "Public",
  free: "Free",
  archival: "Archival",
  premium: "Premium",
  private: "Custom",
  churned: "Churned",
};

export type Status = OpenAPI["schemas"]["EmailStatus"];

// Be careful when changing the order of these! It is directly used in the UI.
export const PRETTY_STATUS: Record<Status, string> = {
  sent: "Sent",
  scheduled: "Scheduled",
  about_to_send: "About to send",
  in_flight: "In flight",
  imported: "Imported",
  draft: "Draft",
  transactional: "Transactional",
  managed_by_rss: "Automated",
  paused: "Paused",
  resending: "Resending",
  throttled: "Throttled",
  deleted: "Deleted",
  errored: "Error",
  suppressed: "Suppressed",
};

export type Source = OpenAPI["schemas"]["EmailSource"];

export const PRETTY_SOURCE: Record<Source, string> = {
  api: "API",
  app: "App",
  import: "Imported",
  external_feed: "RSS",
};

export type Email = OpenAPI["schemas"]["Email"];
export type NewsletterEmailTemplate =
  OpenAPI["schemas"]["NewsletterEmailTemplate"];

const editorMode = v.picklist(["fancy", "plaintext", "naked"]);

export type EditorMode = v.InferInput<typeof editorMode>;

export const isEditorMode = (input: unknown): input is EditorMode => {
  return v.is(editorMode, input);
};
